import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { authHeader, handleResponse } from '../Services/fack.backend';

const PrivateRoute = () => {
  const login = useState(JSON.parse(sessionStorage.getItem('login')))[0];
  const [authenticated, setAuthenticated] = useState(false);
  const jwt_token = sessionStorage.getItem('accessToken');

  useEffect(() => {
    const requestOptions = { method: 'GET', headers: authHeader() };
    fetch('/users', requestOptions).then(handleResponse);
    setAuthenticated(JSON.parse(sessionStorage.getItem('authenticated')));

    sessionStorage.setItem('authenticated', authenticated);
    sessionStorage.setItem('login', login);
  }, []);
  return login || authenticated || jwt_token ? <Outlet /> : <Navigate exact to={`/login`} />;
};

export default PrivateRoute;
